export default {"gitHash":"23223443970bfa7ebfa553e3a07c20e6c477489f","gitHashShort":"2322344","time":1680134131968,"platform":"linux","arch":"x64"};